import React from 'react';
import loadable from '@loadable/component';

import AboveTheFoldOnlyServerRender from '../../../shared/components/above-the-fold-only-server-render';
import { Helpers } from '../../../core/src/helpers';

const CartAbandonContainer = loadable(() => Helpers.retryFunc(() => import('./cart-abandon-container')));

export default () => {
    return (
        <AboveTheFoldOnlyServerRender skip={true}>
            <CartAbandonContainer />
        </AboveTheFoldOnlyServerRender>
    );
};
